import { Component } from '@angular/core';
import { RecommendationContributorEntity } from 'mj_generatedentities';
import { RegisterClass } from '@memberjunction/global';
import { BaseFormComponent } from '@memberjunction/ng-base-forms';
import {  } from "@memberjunction/ng-entity-viewer"

@RegisterClass(BaseFormComponent, 'Contributors') // Tell MemberJunction about this class
@Component({
    standalone: false,
    selector: 'gen-recommendationcontributor-form',
    templateUrl: './recommendationcontributor.form.component.html'
})
export class RecommendationContributorFormComponent extends BaseFormComponent {
    public record!: RecommendationContributorEntity;

    override async ngOnInit() {
        await super.ngOnInit();
        this.initSections([
            { sectionKey: 'details', sectionName: 'Details', isExpanded: true },
            { sectionKey: 'contributorContents', sectionName: 'Contributor Contents', isExpanded: false },
            { sectionKey: 'contributors', sectionName: 'Contributors', isExpanded: false }
        ]);
    }
}

